<template>
    <div class="service-details-wrap ptb-100">
        <div class="container">
            <div class="row gx-5">
                <div class="col-xl-8 col-lg-12">
                    <div class="service-desc">
                        <lightgallery :settings="{ speed: 500, plugins: plugins }" :onInit="onInit" :onBeforeSlide="onBeforeSlide">
                            <a v-for="item in items" :key="item.id" :data-lg-size="item.size" :data-src="item.src">
                                <div class="service-img mb-25 d-block">
                                    <img className="img-responsive" :src="item.thumb" />
                                </div>
                            </a>
                        </lightgallery>
                        <h1>Sound Box Payment Notification</h1>
                        <h3>Instant Alerts. Seamless Transactions. Happy Customers.</h3>
                        <p>
                            The Sound Box is the ultimate payment notification device designed to keep merchants informed
                            and customers satisfied. Built for speed, clarity, and reliability, this compact speaker instantly
                            announces successful payments-loud and clear-so you never miss a sale.
                        </p><p>
                            Whether you are managing a busy retail store, food stall, or delivery service,
                            the Sound Box ensures a smooth cashless experience with real-time voice alerts for every transaction.
                        </p>

                        <h2>Why Merchants Love your Sound Box: </h2>

                        <ul class="content-feature-list style2 list-style">
                            <li><i class="ri-check-line"></i>Boosts trust with instant payment confirmation</li>
                            <li><i class="ri-check-line"></i>Speeds up service with zero need to check your phone</li>
                            <li><i class="ri-check-line"></i>Helps avoid disputes and errors</li>
                            <li><i class="ri-check-line"></i>Perfect for high-volume, fast-paced environments</li>
                        </ul>

                        <h2>Key Features:</h2>
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                            aria-expanded="true" aria-controls="collapseOne">
                                        <span>
                                            <i class="ri-arrow-down-s-line plus"></i>
                                            <i class="ri-arrow-up-s-line minus"></i>
                                        </span>
                                        Real-Time Voice Confirmation
                                    </button>
                                </h2>
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                                     data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <div class="single-product-text">
                                            <p>
                                                Hear every successful payment instantly with crisp,
                                                automated audio alerts in your preferred language.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        <span>
                                            <i class="ri-arrow-down-s-line plus"></i>
                                            <i class="ri-arrow-up-s-line minus"></i>
                                        </span>
                                        Long Battery Life
                                    </button>
                                </h2>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                     data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <p>
                                            Stay powered for days with a high-capacity rechargeable battery, no interruptions,
                                            no worries.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        <span>
                                            <i class="ri-arrow-down-s-line plus"></i>
                                            <i class="ri-arrow-up-s-line minus"></i>
                                        </span>
                                        Stable Connectivity.
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                     data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <p>
                                            Equipped with 3G/4G SIM support and Wi-Fi compatibility to keep you connected at all times.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        <span>
                                            <i class="ri-arrow-down-s-line plus"></i>
                                            <i class="ri-arrow-up-s-line minus"></i>
                                        </span>
                                        Easy Setup & Integration
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                     data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <p>
                                            Plug-and-play design makes onboarding effortless for merchants of all sizes.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        <span>
                                            <i class="ri-arrow-down-s-line plus"></i>
                                            <i class="ri-arrow-up-s-line minus"></i>
                                        </span>
                                        Multi-Platform Compatible
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                     data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <p>
                                            Works seamlessly with our payment apps and digital payment platforms.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h1></h1>
                        <h1></h1>
                        <h3>Case Studies.</h3>
                        <h6>How Sylvie Transformed Her shop with our Sound Box</h6>
                        <div class="post-para">
                            <p>
                                Sylvie owns a small retail kiosk outside a busy street in Yaounde.
                                She sells ladies handbags, shoes, and jewellery. Her stall sees a high footfall every weekend,
                                especially during the morning and evening rush.
                            </p>
                            <!--<p>No sea takimata sanctus est Lorem <router-link to="/">Ipsum</router-link> dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.</p>-->
                            <blockquote class="wp-block-quote">
                                <span class="wp-quote-icon"><i class="flaticon-quotation-mark"></i></span>
                                <div class="wp-quote-text">
                                    <p>
                                        I didn't think something this small could make such a big difference.
                                        Using Sound Box is like having a smart assistant at my kiosk, it doesn't take breaks,
                                        never misses a payment, and helps me sell more.
                                    </p>

                                    <h6>Sylvie</h6>
                                </div>
                            </blockquote>
                            <p>
                                Before the Sound Box, Sylvie had to check the cash to make sure its not fake or her phone for SMS alerts after every payment.
                                During rush hours, this caused a bottleneck. Now, she hears the confirmation instantly and hands over the product in seconds.
                            </p>
                        </div>

                        <!-- Adding new image -->
                        <lightgallery :settings="{ speed: 500, plugins: plugins }" :onInit="onInit" :onBeforeSlide="onBeforeSlide">
                            <a v-for="item in items" :key="item.id" :data-lg-size="item.size" :data-src="item.src">
                                <div class="service-img mb-25 d-block">
                                    <img className="img-responsive" :src="item.thumb1" />
                                </div>
                            </a>
                        </lightgallery>
                        <h1>---------------------------------------------------</h1>
                        <h6>Selling famous Soya at the road side in Douala</h6>
                        <p>
                            Customers were impatient during peak hours, and payment delays caused long queues waiting for change,
                            Often received fake note, resulting in unpaid transactions. At the end of the day, reconciling payments was time-consuming and stressful.
                            Carrying cash is unsafe.
                        </p>
                        <lightgallery :settings="{ speed: 500, plugins: plugins }" :onInit="onInit" :onBeforeSlide="onBeforeSlide">
                            <a v-for="item in items" :key="item.id" :data-lg-size="item.size" :data-src="item.src">
                                <div class="service-img mb-25 d-block">
                                    <img className="img-responsive" :src="item.thumb2" />
                                </div>
                            </a>
                        </lightgallery>

                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">
                    <div class="sidebar">
                        <div class="sidebar-widget style2">
                            <h4>All Services</h4>
                            <div class="category-box style2">
                                <ul class="list-style">
                                    <li>
                                        <router-link to="/service-details">
                                            Mobile Payment
                                            <span><i class="flaticon-next"></i></span>
                                        </router-link>
                                    </li>
                                    <!--<li>
                                      <router-link to="/service-details">
                                        Personal Loans
                                        <span><i class="flaticon-next"></i></span>
                                      </router-link>
                                    </li>-->
                                    <li>
                                        <router-link to="/service-details">
                                            Merchant Onboarding
                                            <span><i class="flaticon-next"></i></span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/service-details">
                                            Mobile Money Integration
                                            <span><i class="flaticon-next"></i></span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/service-details">
                                            Online Payment
                                            <span><i class="flaticon-next"></i></span>
                                        </router-link>
                                    </li>
                                    <!--<li>
                                      <router-link to="/service-details">
                                        Corporate Banking
                                        <span><i class="flaticon-next"></i></span>
                                      </router-link>
                                    </li>-->
                                </ul>
                            </div>
                        </div>
                        <div class="sidebar-widget style2">
                            <h4>Business Hours</h4>
                            <div class="schedule-widget">
                                <ul class="list-style">
                                    <li>
                                        <h6>Mon-Thurs</h6>
                                        <p>8:00 AM - 6:00 PM</p>
                                    </li>
                                    <li>
                                        <h6>Fri-Sat</h6>
                                        <p>8:00 AM - 3:00 PM</p>
                                    </li>
                                    <li>
                                        <h6>Sun</h6>
                                        <p>Closed</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="sidebar-widget style3">
                            <div class="contact-widget-form">
                                <div class="overlay op-95 bg-rock"></div>
                                <h4>Lets Talk</h4>
                                <div v-if="msg">
                                    <p class="text-success">{{ msg }}</p>
                                </div>
                                <form @submit.prevent="sendContactRequest">
                                    <div class="form-group">
                                        <input type="text" placeholder="Name" />
                                    </div>
                                    <div class="form-group">
                                        <input type="email" placeholder="Email" />
                                    </div>
                                    <div class="form-group">
                                        <input type="phone" placeholder="Phone" />
                                    </div>
                                    <div class="form-group">
                                        <textarea name="msg" id="msg" cols="30" rows="10" placeholder="Message"></textarea>
                                    </div>
                                    <button class="btn style1 d-block w-100" type="submit">
                                        Send Message
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Lightgallery from "lightgallery/vue";
    import lgZoom from "lightgallery/plugins/zoom";
    let lightGallery = null;

    export default {
        name: "ServicesDetails",
        components: {
            Lightgallery,
        },
        watch: {
            items() {
                this.$nextTick(() => {
                    lightGallery.refresh();
                });
            },
        },
        data: () => ({
            plugins: [lgZoom],
            items: [
                {
                    id: "1",
                    src: require("../../assets/images/service/single-service-1.jpg"),
                    thumb: require("../../assets/images/service/single-service-1.jpg"),

                    id: "2",
                    src: require("../../assets/images/service/single-service-6.jpg"),
                    thumb1: require("../../assets/images/service/single-service-6.jpg"),

                    id: "3",
                    src: require("../../assets/images/service/single-service-3.jpg"),
                    thumb2: require("../../assets/images/service/single-service-3.jpg"),
                },
            ],
            msg: ""
        }),
        methods: {
            onInit: (detail) => {
                lightGallery = detail.instance;
            },
            onBeforeSlide: () => {
                console.log("calling before slide");
            },
            async sendContactRequest() {
                try {
                    const response = await axios.post('/api/v1/contact/receive-message', {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        message: this.message,
                    });
                    this.msg = "We have received your message. Thanks for you contribution.";
                } catch (error) {
                    console.error(error);
                    const { message } = error.response.data;

                    // Handle the login error
                    this.msg = message || 'Unexpected error, please try again later';
                }
            },
        },
    };
</script>
<style lang="css">
    @import url("https://cdn.jsdelivr.net/npm/lightgallery@2.1.0-beta.1/css/lightgallery.css");
    @import url("https://cdn.jsdelivr.net/npm/lightgallery@2.1.0-beta.1/css/lg-zoom.css");
</style>
